import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import { IReviewItem } from './data-review.component';


@Injectable({
  providedIn: 'root'
})
export class DataReviewService {
protected dataToolsAPI = AppConfig.settings.apiServer.datatoolsServiceUrl + 'DataReview';
constructor(private httpClient:HttpClient) { }
getReviewItem(count:number)
{
  let url = this.dataToolsAPI + `/GetItems?count=${count}`;
  
  return this.httpClient.get(url);
}
saveReviewItem(ItemToReview:IReviewItem)
{
 let url = this.dataToolsAPI + `/SaveItem` 
 const body = JSON.stringify(ItemToReview);
 const headers = {
  'Content-Type': 'application/json',
};
 return this.httpClient.post(url,body, {headers});
}
skipReviewItem(itemId:number)
{
  let url = this.dataToolsAPI + `/SkipItem`;
  const headers = {
    'Content-Type': 'application/json',
  }
  return this.httpClient.post(url,itemId, {headers});
}
getNumberOfReviewItems()
{
  let url = this.dataToolsAPI + `/GetNumberOfItems`;
  return this.httpClient.get(url);
}
getExeclusionReasons()
{
  let url = this.dataToolsAPI + `/GetExclusionReasons`;
  return this.httpClient.get(url);
}
excludeItem(itemId:number, exclusionReasonId:number)
{
  const url = `${this.dataToolsAPI}/ExcludeItem?itemId=${itemId}&exclusionReasonId=${exclusionReasonId}`;
  const headers = {
    'Content-Type': 'application/json',
  }
  return this.httpClient.post(url,null, {headers});
}
}
